import type { ErrorCode } from "@kex-resources/api-errors";

import { useEffect } from "react";

import { useHookOption } from "@features/errors/hooks/use-hook-option";
import {
  ignoreApiError,
  stopIgnoreApiError,
} from "@features/errors/model/api-errors";

export const useIgnoreDefaultApiErrors = <E extends ErrorCode>(
  errors: readonly E[],
) => {
  const errorsOption = useHookOption(errors);
  useEffect(() => {
    const currentErrors = errorsOption.current;
    currentErrors.forEach(ignoreApiError);
    return () => {
      currentErrors.forEach(stopIgnoreApiError);
    };
  }, [errorsOption]);
};
